(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('ProgettoSearch', ProgettoSearch);

    ProgettoSearch.$inject = ['$resource'];

    function ProgettoSearch($resource) {
        var resourceUrl =  'api/_search/progettos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
